const typography = {
    // Existing constants
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    ACTIVE_CAPS: "ACTIVE",
    INACTIVE_CAPS: "INACTIVE",
    ALL: "All",
    FREE: "Free",
    PREMIUM: "Premium",
    NAME: "Name",
    EMAIL: "Email",
    PHONE: "Phone",
    PLAN: "Plan",
    AGE: "Age",
    DATE_OF_BIRTH: "Date of Birth",
    STATUS: "Status",
    ACTION: "Action",
    OCCUPATION: "Occupation",
    GENDER: "Gender",
    MEMBERSHIP_PLAN: "Membership Plan",
    AFFIRMATION_DETAILS: "Affirmation Details",
    DATE: "Date",
    CATEGORY: "Category",
    BLS_DURATION: "BLS Duration",
    FEEDBACK: "Feedback",
    STATUS_UPDATE_CONFIRMATION_MESSAGE:
        "Are you sure you want to update user status?",

    YES: "Yes",
    NO: "No",
    CUSTOMER: "CUSTOMER",
    USER: "USER",

    // New notification-specific constants
    TITLE: "Title",
    NOTIFICATION_MESSAGE: "Notification Message",
    ADD_NOTIFICATION: "Add Notification",
    VIEW_NOTIFICATION: "View Notification",
    EDIT_NOTIFICATION: "Edit Notification",
    SCHEDULE_DATE: "Schedule Date",
    SCHEDULE_TIME: "Schedule Time",
    DELETE_NOTIFICATION_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this notification?",
    SENT: "Sent",
    PENDING: "Pending",
    ADD_NOTIFICATION: "Add Notification",
    SEARCH: "Search",
    VIEW: "View",
    EDIT: "Edit",
    DELETE: "Delete",
    SHOWING_ENTRIES: "Showing {start} to {end} of {total} entries",
};

export default typography;
